import React, { useEffect, useState } from "react";
import {
  about5,
  heroVideo,
  arashBg,
  aboutBg,
  subMenuProjects,
  subMenuHome,
  subMenuPartners,
  newsBg,
} from "../../assets/images";
import Header from "../../Components/Header/Header";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import NewsDetailItems from "./NewsDetailItems/NewsDetailItems";
import axios from "axios";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

const NewsDetail = () => {
  const { t, i18n } = useTranslation();

  const { id } = useParams();
  const currentLanguage = i18n.language || "az";
  const [singleNews, setSingleNews] = useState("");

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(`https://cortex-site.runasp.net/api/Blogs`, {
        withCredentials: false,
      });
      const filteredNews = response.data.find(
        (product) => product.id == id
      );
      setSingleNews(filteredNews);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return "";
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  return (
    <> 
        <Breadcrumb
          title={t("Bloq")}
          content={getLocalizedField(singleNews, "title")}
        />

      <NewsDetailItems />
    </>
  );
};

export default NewsDetail;
